import React from 'react';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';
import EventBasicInfoComponent from './event-basic-info.component';





export const MyEventComponent = ({   back,   selectedEvent }: any) => {

  const tabItems = [
    {
      id: 1,
      title: 'Basic-Info',
      component: (
        <EventBasicInfoComponent

          selectedEvent={selectedEvent}

        />
      ),
      isVisible: true,
    },

    // {
    //   id: 2,
    //   title: 'Forum Groups',
    //   component:
    //     <FroumGroupsValuesComponent
    //       handleDelete={handleDelete}
    //       additionButtons={additionButtons}
    //       handleEdit={handleEdit}
    //       columnDefs={columnDefs}
    //       onInnerBasicFormChange={onInnerBasicFormChange}
    //       selectedForumGroupsValues={selectedForumGroupsValues}
    //         selectedCommunity={selectedCommunity}
    //     />,
    //   isVisible: true,
    // },

 

  ]

  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">


      <TabContainer tabItems={tabItems} />

      <div className='flex w-full justify-end items-end'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
      
      </div>
    </div>
  )
}
export default MyEventComponent;